import BrInputBox from '@components/BrInputBox';

export default function stringFilter() {
  return <BrInputBox name="text" />;
}
